const angular = require('angular');

module.exports = function ($provide) {
    $provide.decorator('$state', [
        '$delegate', '$stateParams', '$injector', '$rootScope', '$anchorScroll', '$location',
            function ($state, $stateParams, $injector, $rootScope, $anchorScroll, $location) {

                const richerRelevanceStateChanged = $injector.get('RRStateChangedService');
                const curationService = $injector.get('CurationService');
                const $q = $injector.get('$q');

            $state.forceReload = function () {

                if ($state.current && $state.current.data && $state.current.data.fullPageRefreshOnForceReload) {
                    window.scrollTo(0, 0);
                    return location.reload();
                }
                // http://stackoverflow.com/a/23198743
                return $state.go($state.current, $stateParams, {
                    reload: true,
                    inherit: false,
                    notify: true
                });
            };

            $state.shouldGetMetaData = function () {
                const toState = $state.current;
                return !toState.data || (toState.data && toState.data.shouldGetMetadata !== false);
            };

            $state.getRicherRelevance = function () {
                const toState = $state.current;
                if (toState.data && toState.data.richer_relevance) {
                    const rr = toState.data.richer_relevance;
                    return angular.isArray(rr)
                        ? $injector.invoke(rr)
                        : $q.resolve(rr);
                }

                return $q.resolve(undefined);
            };

            $state.getMetadata = function () {
                const toState = $state.current;
                if (toState.data && toState.data.pageMetadata) {
                    const isPromise = (obj) => !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
                    const meta = angular.isArray(toState.data.pageMetadata)
                        ? $injector.invoke(toState.data.pageMetadata)
                        : toState.data.pageMetadata;
                    return isPromise(meta) ? meta : Promise.resolve(meta);
                }

                return {
                    title: '',
                    metaDescription: ''
                };
            };

            $state.getAnalytics = function () {
                const toState = $state.current;
                if (toState.data && toState.data.analytics) {
                    return angular.isArray(toState.data.analytics)
                        ? $injector.invoke(toState.data.analytics)
                        : toState.data.dynamicallyRenderAnalyticsWith ? `${toState.data.dynamicallyRenderAnalyticsWith}${window.location.pathname.replace(/\//g, ':')}` : toState.data.analytics;
                }
                return null;
            };

            $state.shouldAuthenticate = function (toState, toParams) {
                return $injector.invoke(toState.data.authenticate, undefined, { toParams });
            };

            $state.previous = undefined;

            $rootScope.$on('$viewContentLoading', function () {
                if (!$state.$current.locals) {
                    $state.$current.locals = {};
                }
            });

            $rootScope.$on('$stateChangeSuccess', (evt, to, toParams, from, fromParams) => {
                const path = $location.path();
                if (path === '/') {
                    curationService.showCuration(path);
                }
                $state.getRicherRelevance().then((rrEvent) => {
                    if (rrEvent) {
                        richerRelevanceStateChanged.notify(rrEvent);
                    }
                });

                // sign out guessed user when they navigate away from the confirmation page
                const CONFIRMATION_PAGE = 'checkout.confirmation';
                if (from.name === CONFIRMATION_PAGE) {
                    const guestSession = $injector.get('ClearGuestSession');
                    guestSession.purge();
                }

                $state.previous = { route: from, routeParams: fromParams };
                $anchorScroll('body-container');
            });

            return $state;
        }
    ]);
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/state.js
 **/